import ShareForm from './ShareForm'
import Preview from '../Preview'
import FieldEdit from '../FieldEdit'

export default function SurveyActionView({ actionId }) {
  const templateFields = useSel(s => s.builder.flow.templateFields)
  const settings = useSel(s => s.builder.flow.settings)
  const flowFields = useSel(s => s.builder.flow.flowFields)
  const publicUrl = useSel(s => s.builder.flow.publicUrl)
  const context = {
    template: templateFields,
    flow: { ...flowFields, current_action_kind: 'share' },
    settings: Object.fromEntries(Object.entries(settings).map(([k, v]) => [_.snakeCase(k), v])),
    client: { brand: JSON.parse(window.ENV.CLIENT_BRAND)}
  }
  const action = useSel(s => s.actions.entities[actionId] || {})

  const componentMap = useMemo(() => ({
    TakeSurveyForm: <>
      <ShareForm
        action={action}
        publicUrl={publicUrl}
        onShare={() => Promise.resolve()}
        onSubmit={() => Promise.resolve()}
      />
    </>,
    FieldEdit,
  }), [action.config])

  return <Preview context={context} componentMap={componentMap} />
}
